/**
 * Jozori brand identity — single source of truth.
 *
 * The tagline is an emotional identity line, not a marketing slogan. It is
 * never used inside a CTA, never with an exclamation point, never alongside
 * urgency words. See docs/BRAND_FEELING.md.
 *
 * Surface rules:
 *  - Child-facing surfaces (in-app, story moments, quiet corner): Arabic only.
 *    The English line is for parents and marketing, not children.
 *  - Parent / marketing / store / email surfaces: bilingual pairing allowed,
 *    AR first, EN as a soft subtitle.
 */
export const TAGLINE = {
  ar: "نكبر بهدوء 🤍",
  en: "Growing gently together.",
  /** Plain-text bilingual joiner for store metadata, OG descriptions, etc. */
  bilingual: "نكبر بهدوء 🤍 · Growing gently together.",
} as const;

export const BRAND_NAME = {
  ar: "جذوري",
  en: "Jozori",
  bilingual: "Jozori | جذوري",
} as const;
